// extracted by mini-css-extract-plugin
export default {"title":"touristsFooterDesktop-module__title__cdJ6t","button":"touristsFooterDesktop-module__button__32sY7","loader":"touristsFooterDesktop-module__loader__IC9cG"};